import { TagValue, TagValuesResponseDTO } from '@dto/tagValue.dto';
import { getApi } from 'src/util/apiCalls';

export const fetchTagValuesByCategory = async (
  categoryName: string,
  signal?: AbortSignal
): Promise<TagValue[]> => {
  const response = await getApi<TagValuesResponseDTO>(
    `/api/tag/v1/value/name?tag_label=${encodeURIComponent(categoryName)}`,
    signal
  );

  return response.data?.data || [];
};
